import React, { useState } from "react";
import config from "lib/fr-config";
import WrongPathErrorView from "presentational/error/WrongPathErrorView/WrongPathErrorView";
import RootItemProfileView from "presentational/itemDetail/RootItemProfileView";
import RootOutfitWithItemListView from "presentational/itemDetail/RootOutfitWithItemListView";
import ItemNoteInputModalView from "presentational/itemDetail/ItemNoteInputModalView";
import IconButtonView from "presentational/common/IconButtonView";
import TXT from "presentational/common/multinational/TXT";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import { getDeviceType } from "lib/deviceInfo";
import PropTypes from "prop-types";

const desktopCss = config.css.desktop;
const mobileCss = config.css.mobile;
const fontCss = config.css.fontThickness;

const deviceType = getDeviceType();

const TitleTypography = withStyles({
  root: {
    fontSize:
      deviceType === "desktop"
        ? desktopCss.sectionTitleFontSizePX
        : mobileCss.sectionTitleFontSizePX,
    fontWeight: fontCss.bold,
    lineHeight: 1
  }
})(Typography);
const NoteQuestionTypography = withStyles({
  root: {
    fontSize:
      deviceType === "mobile"
        ? mobileCss.fontSizeOfItemDetail.normalText
        : desktopCss.fontSizeOfItemDetail.normalText,
    fontWeight: fontCss.bold
  }
})(Typography);
const NoteAnswerTypography = withStyles({
  root: {
    fontSize:
      deviceType === "mobile"
        ? mobileCss.fontSizeOfItemDetail.normalText
        : desktopCss.fontSizeOfItemDetail.normalText,
    paddingLeft: 10,
    paddingBottom: 6
  }
})(Typography);

const css = {
  noteArea: {
    paddingTop: 24,
    marginBottom:
      getDeviceType() === "mobile"
        ? mobileCss.standardPaddingBetweenContent
        : desktopCss.standardPaddingBetweenContent,
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row-reverse"
  },
  noteAddBtnWrapper: {},
  noteContentWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start"
  },
  sectionTitleWrapper: {
    paddingBottom:
      deviceType === "desktop"
        ? desktopCss.sectionTitleBottomPadding
        : mobileCss.sectionTitleBottomPadding,
    display: "flex",
    justifyContent: "flex-end"
  },
  memoTextWrapper: {
    // 줄바꿈 화면에 표시되도록 하기 위해
    whiteSpace: "pre-line"
  }
};

ItemDetailPanelView.propTypes = {
  itemInfo: PropTypes.object,
  memoData: PropTypes.object.isRequired,
  outfitList: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isEnd: PropTypes.bool.isRequired,
  getNextList: PropTypes.func.isRequired,
  onMemoSubmitClick: PropTypes.func.isRequired
};

function ItemDetailPanelView(props) {
  const {
    itemInfo,
    memoData,
    outfitList,
    isLoading,
    isEnd,
    getNextList,
    onMemoSubmitClick
  } = props;
  const [noteInputModalOpen, setNoteInputModalOpen] = useState(false);

  const { nickname, place, sizeDetail, memo } = memoData;

  const handleAddNoteBtnClick = () => {
    setNoteInputModalOpen(true);
  };

  const HandleMemoSubmit = ({
    nickname,
    place,
    sizeDetail,
    memo,
    hasNicknameChanged
  }) => {
    onMemoSubmitClick({
      nickname,
      place,
      sizeDetail,
      memo,
      hasNicknameChanged
    });
  };

  const handleModalClose = () => {
    setNoteInputModalOpen(false);
  };

  return itemInfo && itemInfo.wrongItemHash ? (
    <WrongPathErrorView />
  ) : (
    <div>
      <RootItemProfileView itemInfo={itemInfo} />
      {!!itemInfo && (
        <div>
          <div style={css.noteArea}>
            <div style={css.noteAddBtnWrapper}>
              <IconButtonView
                type={"addNote"}
                onClick={handleAddNoteBtnClick}
                buttonSize={"small"}
                fontSize={"medium"}
                color={"default"}
              />
            </div>
            <div style={css.noteContentWrapper}>
              {!!nickname && nickname.length > 0 && (
                <div>
                  <NoteQuestionTypography>"{nickname}"</NoteQuestionTypography>
                  <NoteAnswerTypography></NoteAnswerTypography>
                </div>
              )}
              {!!place && place.length > 0 && (
                <div>
                  <NoteQuestionTypography>보관 위치</NoteQuestionTypography>
                  <NoteAnswerTypography>
                    <span style={css.memoTextWrapper}>{place}</span>
                  </NoteAnswerTypography>
                </div>
              )}
              {!!sizeDetail && sizeDetail.length > 0 && (
                <div>
                  <NoteQuestionTypography>사이즈 정보</NoteQuestionTypography>
                  <NoteAnswerTypography>
                    <span style={css.memoTextWrapper}>{sizeDetail}</span>
                  </NoteAnswerTypography>
                </div>
              )}
              {!!memo && memo.length > 0 && (
                <div>
                  <NoteQuestionTypography>메모</NoteQuestionTypography>
                  <NoteAnswerTypography>
                    <span style={css.memoTextWrapper}>{memo}</span>
                  </NoteAnswerTypography>
                </div>
              )}
            </div>
          </div>
          <div style={css.sectionTitleWrapper}>
            <TitleTypography>
              <TXT name="titleSection_outfits" />
            </TitleTypography>
          </div>
          <RootOutfitWithItemListView
            list={outfitList}
            isLoading={isLoading}
            isEnd={isEnd}
            callNextListFn={getNextList}
          />
          <ItemNoteInputModalView
            open={noteInputModalOpen}
            onClose={handleModalClose}
            nickname={nickname}
            place={place}
            sizeDetail={sizeDetail}
            memo={memo}
            onMemoSubmit={HandleMemoSubmit}
          />
        </div>
      )}
    </div>
  );
}

export default ItemDetailPanelView;
